// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fFjpH","content":"styles_content__v3WA2"};